import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import CTAButtonPersonalized, { type CtaExposures } from "@/components/custom/CtaButton/CTAButtonPersonalized";
import { Prose } from "@/components/custom/Prose";
import { cn } from "@/lib/utils";
import type { ContentImage } from "@/types/contentful/ContentImage";
import type { TypeButton, TypeExternalButton, TypeProse } from "@/types/contentful/generated";
type ButtonEntry = TypeButton<undefined, string> | TypeExternalButton<undefined, string>;
interface Props {
  heading: string;
  subheading: string;
  prose: TypeProse<undefined, string>;
  cta?: ButtonEntry;
  ctaExposures?: CtaExposures;
  image: ContentImage;
  alignment: "Image left" | "Image right";
}
export function EditorialSide(t0) {
  const $ = _c(30);
  const {
    heading,
    subheading,
    prose,
    cta,
    ctaExposures,
    image,
    alignment
  } = t0;
  const t1 = alignment === "Image right" ? "lg:flex-row" : "lg:flex-row-reverse";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex flex-col lg:items-start gap-12 w-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sideClass = t2;
  let t3;
  if ($[2] !== image.alt || $[3] !== image.src) {
    t3 = <div className="relative w-full aspect-video rounded-md overflow-hidden lg:hidden"><Image src={image.src} alt={image.alt} fill={true} sizes="100vw" className="object-cover" /></div>;
    $[2] = image.alt;
    $[3] = image.src;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== heading) {
    t4 = <h2 className="heading-sm">{heading}</h2>;
    $[5] = heading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== subheading) {
    t5 = <h3 className="heading-xs">{subheading}</h3>;
    $[7] = subheading;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== prose.fields.content) {
    t7 = <Prose content={prose.fields.content} />;
    $[12] = prose.fields.content;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== cta || $[15] !== ctaExposures) {
    t8 = cta && <CTAButtonPersonalized entry={cta} exposures={ctaExposures?.[cta.sys.id]} className="w-fit" />;
    $[14] = cta;
    $[15] = ctaExposures;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex flex-col lg:w-1/2 min-w-0 gap-6">{t6}{t7}{t8}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="w-full aspect-video" />;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== image.alt || $[23] !== image.src) {
    t11 = <div className="hidden lg:flex relative lg:w-1/2 rounded-md overflow-hidden">{t10}<Image src={image.src} alt={image.alt} fill={true} sizes="50vw" className="object-cover" /></div>;
    $[22] = image.alt;
    $[23] = image.src;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== sideClass || $[26] !== t11 || $[27] !== t3 || $[28] !== t9) {
    t12 = <div className={sideClass}>{t3}{t9}{t11}</div>;
    $[25] = sideClass;
    $[26] = t11;
    $[27] = t3;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}